import { Link } from "react-router-dom";
import TrustStrip from "./TrustStrip";

const LOGO_URL =
  "https://static.readdy.ai/image/630c6b1470b412c02a23d556f94f9bee/4d2e9b251244fac3d3a565feae080dc8.webp";

export default function Footer() {
  return (
    <>
      <TrustStrip />
      <footer className="bg-[#0F2040] text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            {/* Brand */}
            <div className="lg:col-span-1">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg">
                  <img
                    src={LOGO_URL}
                    alt="Mighty Cleaning Services Ltd"
                    className="w-10 h-10 object-contain"
                  />
                </div>
                <div>
                  <span className="font-heading font-700 text-base block" style={{ fontWeight: 700 }}>Mighty Cleaning</span>
                  <span className="text-blue-300 text-xs">Services Ltd</span>
                </div>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-5">
                Your trusted local window cleaning experts in Northfleet, Gravesend, Kent and surrounding areas. Professional, reliable, and fully insured.
              </p>
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-1.5 bg-white/10 rounded-lg px-3 py-2">
                  <i className="ri-star-fill text-yellow-400 text-sm"></i>
                  <span className="text-sm font-semibold">4.9</span>
                  <span className="text-gray-400 text-xs">Google</span>
                </div>
                <div className="flex items-center gap-1.5 bg-white/10 rounded-lg px-3 py-2">
                  <i className="ri-star-fill text-yellow-400 text-sm"></i>
                  <span className="text-sm font-semibold">4.8</span>
                  <span className="text-gray-400 text-xs">Facebook</span>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-blue-300 mb-5">
                <a href="#quick-links">Quick Links</a>
              </h4>
              <ul className="space-y-3">
                {[
                  { label: "Home", path: "/" },
                  { label: "About Us", path: "/about" },
                  { label: "Our Services", path: "/services" },
                  { label: "Contact Us", path: "/contact" },
                ].map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer flex items-center gap-2 group"
                    >
                      <i className="ri-arrow-right-s-line text-[#1E88E5] group-hover:translate-x-1 transition-transform"></i>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-blue-300 mb-5">
                <a href="#our-services">Our Services</a>
              </h4>
              <ul className="space-y-3">
                {[
                  "Residential Window Cleaning",
                  "Commercial Window Cleaning",
                  "Conservatory & Glass Cleaning",
                  "Regular Maintenance Cleaning",
                  "Residential Gutter Clearance",
                  "Commercial Gutter Clearance",
                  "Fascia & Soffit Cleaning",
                  "Cladding Cleaning",
                  "Pressure Washing",
                  "Solar Panel Cleaning",
                  "Conservatory Roof Cleaning",
                ].map((s) => (
                  <li key={s}>
                    <Link
                      to="/services"
                      className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer flex items-center gap-2 group"
                    >
                      <i className="ri-arrow-right-s-line text-[#1E88E5] group-hover:translate-x-1 transition-transform"></i>
                      {s}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-blue-300 mb-5">
                <a href="#contact-us">Contact Us</a>
              </h4>
              <ul className="space-y-4">
                <li>
                  <a
                    href="tel:02084322244"
                    className="flex items-start gap-3 text-gray-300 hover:text-white transition-colors cursor-pointer group"
                  >
                    <div className="w-8 h-8 flex items-center justify-center bg-[#1E88E5]/20 rounded-lg mt-0.5 flex-shrink-0">
                      <i className="ri-phone-fill text-[#1E88E5] text-sm"></i>
                    </div>
                    <span className="text-sm font-semibold group-hover:text-white">0208 43 222 44</span>
                  </a>
                </li>
                <li className="flex items-start gap-3 text-gray-400">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#1E88E5]/20 rounded-lg mt-0.5 flex-shrink-0">
                    <i className="ri-map-pin-fill text-[#1E88E5] text-sm"></i>
                  </div>
                  <span className="text-sm leading-relaxed">
                    Northfleet, Kent
                  </span>
                </li>
                <li className="flex items-start gap-3 text-gray-400">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#1E88E5]/20 rounded-lg mt-0.5 flex-shrink-0">
                    <i className="ri-time-fill text-[#1E88E5] text-sm"></i>
                  </div>
                  <span className="text-sm">Mon – Fri: 9:00 AM – 5:00 PM</span>
                </li>
              </ul>
              <Link
                to="/services"
                className="mt-5 inline-flex items-center gap-2 bg-[#1E88E5] hover:bg-[#1565C0] text-white font-heading font-semibold text-sm px-5 py-2.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Get a Free Quote
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              © 2026 Mighty Cleaning Services Ltd. All rights reserved.
            </p>
            <div className="flex items-center gap-5 text-gray-500 text-sm">
              <a href="#privacy" rel="nofollow" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <span>|</span>
              <a href="#terms" rel="nofollow" className="hover:text-white transition-colors cursor-pointer">Terms</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
